import { render, staticRenderFns } from "./ProjectObjectsTable.vue?vue&type=template&id=70f84eb8&scoped=true&"
import script from "./ProjectObjectsTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectObjectsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectObjectsTable.vue?vue&type=style&index=0&id=70f84eb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f84eb8",
  null
  
)

export default component.exports